import { axiosAdmin } from "config/axios.config";

const DESC_URL = "/doc/description";

const descriptionSvc = {
  getAll: async () => {
    const response = await axiosAdmin.get(`${DESC_URL}`);
    return response;
  },
  getById: async (id) => {
    const response = await axiosAdmin.get(`${DESC_URL}/${id}`);
    return response;
  },
  getByTitleId: async (id) => {
    const response = await axiosAdmin.get(`${DESC_URL}/title/${id}`);
    return response;
  },
  create: async (body) => {
    const response = await axiosAdmin.post(`${DESC_URL}`, body);
    return response;
  },
  update: async (id, body) => {
    const response = await axiosAdmin.put(`${DESC_URL}/${id}`, body);
    return response;
  },
  delete: async (id) => {
    const response = await axiosAdmin.delete(`${DESC_URL}/${id}`);
    return response;
  },
};

export default descriptionSvc;
